import {
  isAddressDataHasHouse,
  isAddressDataHasTerritory,
  getStreetAndHouseFromAddress,
} from 'shared/lib/addressFields';
import type { TDadataFullAddressSelectOption } from 'shared/types';

/**
 * Считает адрес валидным по списку уличных подсказок, если:
 * - есть хотя бы одна подсказка
 * - все подсказки относятся к одной и той же улице
 * - у первой подсказки заполнен house или territory
 */
export const isAddressValidFromStreetSuggestions = (items: TDadataFullAddressSelectOption[]) => {
  if (!items.length) {
    return false;
  }

  const { data: firstItemData, value } = items[0];
  const { street: streetPart } = getStreetAndHouseFromAddress(value);

  const isEverySuggestItemStartsWithPart = items.every((item) => item.value.startsWith(streetPart));

  if (isEverySuggestItemStartsWithPart) {
    return isAddressDataHasHouse(firstItemData) || isAddressDataHasTerritory(firstItemData);
  }

  return false;
};
